<template>
  <div ref="root" class="dropdown" :class="{ 'is-active': expanded }" @focusout="focusOut">
    <div class="dropdown-trigger">
      <button
        class="button is-borderless"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        @click="expanded = !expanded"
      >
        <span class="icon is-small">
          <span v-show="modelValue === true" class="has-text-success">
            <i class="fas fa-equals"></i>
          </span>
          <span v-show="modelValue === false" class="has-text-danger">
            <i class="fas fa-not-equal"></i>
          </span>
          <span v-show="modelValue === null" class="has-text-success">
            <i class="fas fa-check"></i>
          </span>
        </span>
        <span>{{ caption }}</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </div>
    <div id="dropdown-menu" class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          href=""
          class="dropdown-item"
          :class="classesForState(null)"
          @click.prevent="select(null)"
        >
          {{ nullCaption }}
        </a>
        <a
          href=""
          class="dropdown-item"
          :class="classesForState(false)"
          @click.prevent="select(false)"
        >
          {{ falseCaption }}
        </a>
        <a
          href=""
          class="dropdown-item"
          :class="classesForState(true)"
          @click.prevent="select(true)"
        >
          {{ trueCaption }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>import { ref as _ref } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: false, default: null },
    caption: { type: String, required: true },
    trueCaption: { type: String, required: false, default: "Only" },
    falseCaption: { type: String, required: false, default: "Exclude" },
    nullCaption: { type: String, required: false, default: "Include" },
  });

  const emit = defineEmits(["update:model-value"]);

  const root = _ref(null);

  let expanded = _ref(false);

  const classesForState = (state) => {
    return {
      "is-active": props.modelValue === state,
    };
  };

  const focusOut = () => {
    if (!root.value.matches(":focus-within")) {
      expanded.value = false;
    }
  };

  const select = (state) => {
    expanded.value = false;
    emit("update:model-value", state);
  };
</script>
